import React from "react";
import { SelectionRectangle } from "./ui/SelectionRectangle";
import type { WorkspaceState } from "../utils/workspace.types";

interface ViewportOverlaysProps {
  state: WorkspaceState;
  // nodes kept for compatibility but unused after tooltip removal
  nodes: any[]; // eslint-disable-line @typescript-eslint/no-unused-vars
}

/**
 * Viewport Overlays component - all overlay UI elements
 * Extracted from STAADWorkspace3D to maintain exact behavior
 */
export const ViewportOverlays: React.FC<ViewportOverlaysProps> = ({
  state,
  nodes: _nodes,
}) => {
  // hoveredNode tooltip removed — no longer required

  return (
    <>
      {/* Node Creation Mode Indicator */}
      {/* {state.isNodeCreationMode && (
        <div className="absolute top-4 left-1/2 transform -translate-x-1/2 bg-green-600 bg-opacity-90 text-white px-4 py-2 rounded-lg shadow-lg z-40">
          <div className="flex items-center gap-2">
            <span className="text-sm font-medium">🎯 Node Creation Mode</span>
            <span className="text-xs opacity-90">• Click on beams to create nodes automatically</span>
            <span className="text-xs opacity-90">• Click elsewhere for manual coordinates</span>
          </div>
        </div>
      )} */}

      {/* Beam Creation Mode Indicator */}
      {/* {state.isBeamCreationMode && (
        <div className="absolute top-4 left-1/2 transform -translate-x-1/2 bg-blue-600 bg-opacity-90 text-white px-4 py-2 rounded-lg shadow-lg z-40">
          <div className="flex items-center gap-2">
            <span className="text-sm font-medium">🔗 Beam Creation Mode</span>
            <span className="text-xs opacity-90">• Click nodes to create beams</span>
          </div>
        </div>
      )} */}

      {/* Selection Mode Indicator */}
      {/* {state.isSelectionMode && (
        <div className="absolute top-4 left-1/2 transform -translate-x-1/2 bg-purple-600 bg-opacity-90 text-white px-4 py-2 rounded-lg shadow-lg z-40">
          <div className="flex items-center gap-2">
            <span className="text-sm font-medium">📦 Selection Mode Active</span>
            <span className="text-xs opacity-90">• Drag to select elements</span>
            <span className="text-xs opacity-90">• Ctrl+Drag for additive selection</span>
            <span className="text-xs opacity-90">• Double-click to exit</span>
          </div>
        </div>
      )} */}

      {/* Selection Rectangle */}
      <SelectionRectangle
        isVisible={state.isDraggingSelection}
        start={state.selectionStart}
        end={state.selectionEnd}
      />

      {/* Coordinate tooltip feature removed per request */}

      {/* Debug info for selection mode */}
      {state.isSelectionMode && (
        <div className="absolute bottom-4 left-4 bg-black bg-opacity-70 text-white text-xs p-2 rounded">
          <div>Selection Mode: {state.isSelectionMode ? "ON" : "OFF"}</div>
          <div>Ctrl Pressed: {state.isCtrlPressed ? "YES" : "NO"}</div>
          <div>Dragging: {state.isDraggingSelection ? "YES" : "NO"}</div>
          {state.selectionStart && state.selectionEnd && (
            <div>
              Selection: {Math.round(state.selectionStart.x)},
              {Math.round(state.selectionStart.y)} →{" "}
              {Math.round(state.selectionEnd.x)},
              {Math.round(state.selectionEnd.y)}
            </div>
          )}
        </div>
      )}
    </>
  );
};
